// Cash-drawer denominations + count helpers. (DailyCashCountModal and
// KioskCashCloseView still carry their own local copies from before this
// module existed — consolidating those is a separate cleanup.)

export const CASH_DENOMS = [
  { key: '100',     label: '$100 bill',  value: 100 },
  { key: '50',      label: '$50 bill',   value:  50 },
  { key: '20',      label: '$20 bill',   value:  20 },
  { key: '10',      label: '$10 bill',   value:  10 },
  { key: '5',       label: '$5 bill',    value:   5 },
  { key: '2',       label: '$2 bill',    value:   2 },
  { key: '1',       label: '$1 bill',    value:   1 },
  { key: 'quarter', label: 'Quarter',    value: 0.25, sub: '25¢' },
  { key: 'dime',    label: 'Dime',       value: 0.10, sub: '10¢' },
  { key: 'nickel',  label: 'Nickel',     value: 0.05, sub: '5¢'  },
  { key: 'penny',   label: 'Penny',      value: 0.01, sub: '1¢'  },
];

// { key: qty } → quantity array aligned to CASH_DENOMS.
export function denomQtyFromObj(obj) {
  const out = CASH_DENOMS.map(() => 0);
  if (!obj || typeof obj !== 'object') return out;
  CASH_DENOMS.forEach((d, i) => { out[i] = Math.max(0, Math.floor(Number(obj[d.key]) || 0)); });
  return out;
}

// Quantity array → { key: qty } for keys with a positive count.
export function denomObjFromQty(qty) {
  const out = {};
  CASH_DENOMS.forEach((d, i) => { if (qty[i] > 0) out[d.key] = qty[i]; });
  return out;
}

// Sum of qty × value, rounded to cents.
export function denomTotal(qty) {
  let t = 0;
  CASH_DENOMS.forEach((d, i) => t += (qty[i] || 0) * d.value);
  return Math.round(t * 100) / 100;
}

export function fmtCash(n) { return '$' + (Math.round((Number(n) || 0) * 100) / 100).toFixed(2); }
